/**
 * 扩展obj
 * @param dest
 * @param obj
 * @returns {*}
 */
export function extendSimple(dest, obj) {
  dest = dest || {};
  for (var i in obj) {
    dest[i] = obj[i];
  }
  return dest;
}

/**
 * 对象转query
 * @param obj
 * @returns {string}
 */
export function obj2Query(obj) {
  let query = '';
  Object.keys(obj).forEach(function (key, index) {
    const ifAnd = (index === 0 ? '' : '&');
    query = query + ifAnd + key + '=' + encodeURIComponent(obj[key]);
  });
  return query;
}

/**
 * 空函数
 */
export function noop() {

}

/**
 * 简单封装ajax
 * @param {option} obj 同jq的ajax参数
 */
export function ajax(obj) {
  let xhr = new window.XMLHttpRequest();

  // default get
  if (!obj.method) {
    obj.method = 'get';
  }

  // get
  if (obj.method === 'get') {
    obj.data = params(obj.data);
    obj.url += (obj.url.indexOf('?') === -1 ? '?' : '&') + obj.data;
  }

  // cache
  if (obj.cache !== true) {
    obj.url += (obj.url.indexOf('?') === -1 ? '?' : '&') + '_=' + new Date().getTime();
  }

  // async
  obj.async = obj.async !== false;
  if (obj.async !== false) {
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        callback();
      }
    };
  }

  xhr.open(obj.method, obj.url, obj.async);

  // 增加header信息
  if (obj.headers) {
    for (var header in obj.headers) {
      xhr.setRequestHeader(header, obj.headers[header]);
    }
  } else {
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
  }

  if (obj.method === 'post') {
    xhr.send(JSON.stringify(obj.data));
  } else {
    xhr.send(null);
  }

  // 同步
  if (obj.async === false) {
    callback();
  }

  function callback() {
    if (xhr.status === 200) {
      let response = xhr.responseText;
      if (obj.dataType === 'json') {
        response = JSON.parse(response);
      }
      obj.success && obj.success(response);
    } else {
      obj.error && obj.error(xhr.status, xhr.statusText);
    }
  }
}

/**
 * 名值对转换为字符串 如{name:'jalon', age: 23} => name=jalon&age=23
 * @param {对象} data
 */
export function params(data) {
  let arr = [];
  for (let i in data) {
    // 特殊字符传参产生的问题可以使用encodeURIComponent()进行编码处理
    arr.push(encodeURIComponent(i) + '=' + encodeURIComponent(data[i]));
  }
  return arr.join('&');
}




// WEBPACK FOOTER //
// ./src/pages/epower/bridge/ddbridgebeatles/beatles/util/method.js